import { Link } from "react-router-dom";

export default function FinalCta() {
  return (
    <section className="relative py-20 md:py-28 px-4 md:px-6 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Soft%20elegant%20minimal%20lifestyle%20flat%20lay%20with%20warm%20cream%20and%20sand%20textured%20linen%20background%2C%20scattered%20neutral%20toned%20fabric%20swatches%20and%20small%20refined%20fashion%20details%2C%20gentle%20diffused%20side%20lighting%2C%20high%20end%20editorial%20catalog%20style%2C%20clean%20artistic%20composition%2C%20warm%20ambient%20atmosphere%2C%20soft%20organic%20shadows%2C%20elegant%20texture%20contrast%2C%20sophisticated%20aesthetic&width=1800&height=800&seq=cta-bg-v2&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/35" />

      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-4xl text-white mb-4">
          Ready to Master BaseTao Spreadsheet?
        </h2>
        <p className="text-white/75 text-sm md:text-base mb-8 max-w-lg mx-auto">
          Start organizing your hauls, tracking orders, and saving money with the most comprehensive BaseTao Spreadsheet resources available online.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-xl bg-primary-500 text-white hover:bg-primary-600 text-base font-semibold transition-all cursor-pointer whitespace-nowrap"
          >
            Visit Main Website <i className="ri-arrow-right-up-line"></i>
          </a>
          <Link
            to="/article/basetao-shopping-guide"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-xl bg-white/15 backdrop-blur-sm text-white hover:bg-white/25 border border-white/20 text-base font-medium transition-all cursor-pointer whitespace-nowrap"
          >
            Shopping Guide <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}